(() => {
  var ProductFaq = class extends HTMLElement {
    constructor() {
      super();
    }

    async connectedCallback() {
      await this.fetchPage();
    }

    async fetchPage() {
      const parser = new DOMParser();
      fetch(`/pages/${this.dataset.handle}`)
        .then((r) => r.text())
        .then((response) => {
          let responseDom = parser.parseFromString(response, "text/html");
          let sectionId = responseDom
            .querySelector(".shopify-section--faq")
            .getAttribute("id");
          this.setAttribute("id", sectionId);
          this.innerHTML =
            responseDom.querySelector(".shopify-section--faq style").outerHTML +
            responseDom.querySelector(".shopify-section--faq .section")
              .innerHTML;
        });
    }
  };

  window.customElements.define("product-faq", ProductFaq);
})();
